import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-overlay showbox" }




export default /*@__PURE__*/_defineComponent({
  __name: 'ComponentLoader',
  props: ['loading'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "loader" }, [
      _createElementVNode("svg", {
        class: "circular",
        viewBox: "25 25 50 50"
      }, [
        _createElementVNode("circle", {
          class: "path",
          cx: "50",
          cy: "50",
          r: "20",
          fill: "none",
          "stroke-width": "2",
          "stroke-miterlimit": "10"
        })
      ])
    ], -1)
  ]), 512)), [
    [_vShow, __props.loading]
  ])
}
}

})